import React from "react";
import { Answers, Config, Diagnosis } from "../../types";
import { SingleSelectStep } from "../SingleSelectStep";

export function DiagnosisStep({
	config,
	onSelect,
	answers,
}: {
	config: Config;
	onSelect: (value: string) => void;
	answers: Answers;
}) {
	const selectedProtocol = config.protocols.find((p) => String(p.id) === String(answers.protocol));
	const diagnoses = selectedProtocol?.diagnoses ?? [];
	return (
		<SingleSelectStep
			layout="list"
			options={diagnoses.map((p) => ({
				id: String(p.id),
				label: p.displayName,
				isSelected: String(answers.diagnosis) === String(p.id),
			}))}
			onSelect={onSelect}
		/>
	);
}
